import type { Config } from '@empathyco/playboard-core-domain'
import type { GetterClass, InstanceManagementState } from '../../../models'

export class ServicesConfigGetter implements GetterClass {
  static execute(this: void, state: InstanceManagementState): Config[] {
    return state.serviceConfigs
  }
}
